import { blue } from '@mui/material/colors';

export const addFieldsStyles = {
	root: {
		pt: 2
	},

	chipRow: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: 1
	},

	label: {
		color: 'text.primary',
		fontSize: '14px',
		fontWeight: 400,
		flexShrink: 0
	},

	chip: {
		border: '1px solid',
		borderColor: blue[200],
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: `${blue[100]} !important`
		}
	},

	browseAllLink: {
		textTransform: 'none',
		fontSize: '13px',
		fontWeight: 400,
		px: 1,
		py: 0,
		minWidth: 0,
		flexShrink: 0
	}
};
